var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('portal',{attrs:{"to":"modals-sub"}},[_c('contact-create-or-update-modal')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }